export default __webpack_public_path__ + "static/media/i-stack-4.3b3c50d8.svg";